import React, { useState, useEffect } from "react";
import { Container, Grid, Typography } from "@mui/material";
import { FeatureResponse } from "../../../services/models";
import apiClient from "../../../utils/api";
import AddClassFeature from "./AddClassFeature";
import AddUserFeature from "./AddUserFeature";
import ListClassFeatures from "./ListClassFeatures";
import ListAllFeatures from "./ListAllFeatures";

export const FeatureFlags: React.FC = () => {
  const [classFeatures, setClassFeatures] = useState<FeatureResponse[]>([]);
  const [classes, setClasses] = useState<string[]>([]);

  useEffect(() => {
    fetchClasses();
  }, []);

  const fetchClasses = async () => {
    try {
      const response = await apiClient.classControllerList();
      setClasses(response.classIds);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const fetchClassFeatures = async (classId: string) => {
    const features = await apiClient.featureFlagsControllerListClassFeatures({
      classId,
    });
    setClassFeatures(features);
  };

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Feature Flags Management
      </Typography>
      <Grid container spacing={3}>
        <AddClassFeature
          classes={classes}
          fetchClassFeatures={fetchClassFeatures}
        />
        <AddUserFeature />
      </Grid>
      <Grid container spacing={3} style={{ marginTop: "20px" }}>
        <ListClassFeatures
          classes={classes}
          classFeatures={classFeatures}
          fetchClassFeatures={fetchClassFeatures}
        />
        <ListAllFeatures />
      </Grid>
    </Container>
  );
};
